export default {"src":"https://fishbrain.com/_next/static/media/oregon.2b9dd874.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};